export default "__VITE_ASSET__5f8b90be__"